module.exports = __webpack_public_path__ + "static/img/avatar.bf6713e2.png";